











import { defineComponent, ref } from '@nuxtjs/composition-api'
import RegisterForm from '~/modules/customer/components/LoginModal/forms/RegisterForm.vue';
import SocialLogin from '~/modules/customer/components/LoginModal/forms/SocialLogin.vue';
import { RegisterFormFields } from '~/modules/customer/components/LoginModal/forms/types';
import { loginAvailableViews } from '~/utils/constants/layout';

export default defineComponent({
    props: {

        changeView: {
            type: Function,
            required: true
        },
        showSocialLoginButtons: {
            type: Boolean,
            required: true
        }
    },
    components: {
        SocialLogin,
        RegisterForm
    },
    setup() {
        /** valori iniziali della form */
        const registerForm = ref<RegisterFormFields>({
            email: '',
            firstName: '',
            lastName: '',
            password: '',
            consensoMail: null,
            consensoProfilazione: null,
            consensoSocieta: null
        });
        return {
            registerForm,
            loginAvailableViews
        }
    },
})
